import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorBillingNitService } from 'src/app/services/vendor-billing-nit.service';
import { VendorService } from 'src/app/services/vendor.service';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-modal-vendor-billing-nit',
  templateUrl: './modal-vendor-billing-nit.component.html',
  styleUrls: ['./modal-vendor-billing-nit.component.scss']
})
export class ModalVendorBillingNitComponent implements OnInit {

  @Input() vendor: any;

  @Output() close = new EventEmitter<boolean>();

  loading = false;
  saving = false;

  percentage: number = 100;

  billingNits: any[] = [];

  billingNitInput: string = '';
  billingNameInput: string = '';

  messageNIT: string = '';

  constructor(
    private vendorBillingNitService: VendorBillingNitService,
    private vendorService: VendorService,
    private toastService: ToastrService,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    if (!this.vendor?.id) {
      this.toastService.info('Debes seleccionar un cliente');
      this.close.emit(false);
      return;
    }

    this.percentage = this.vendor.percentage ?? 100;

    this.getBillingNits();
  }

  getBillingNits(): void {
    this.loading = true;

    this.vendorBillingNitService
      .getVendorBillingNitById(this.vendor.id)
      .subscribe({
        next: (response: ResponseObject) => {
          this.billingNits = response.data || [];
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;

          this.toastService.error(
            error.error?.message ||
            'No se pudieron cargar los NIT de facturación'
          );
        }
      });
  }

  addBillingData(): void {

    const billingNit = this.billingNitInput?.trim();
    const billingName = this.billingNameInput?.trim();

    if (!billingNit || !billingName) {
      this.toastService.info(
        'Debes ingresar el NIT y el nombre de facturación'
      );
      return;
    }

    const exists = this.billingNits.some(item =>
      item.billingNit &&
      item.billingNit.trim().toLowerCase() ===
      billingNit.toLowerCase()
    );

    if (exists) {
      this.toastService.info(
        'El NIT de facturación ya se encuentra agregado'
      );
      return;
    }

    this.billingNits.push({
      billingNit: billingNit,
      billingName: billingName
    });

    this.billingNitInput = '';
    this.billingNameInput = '';
  }

  deleteBillingData(index: number): void {
    this.billingNits.splice(index, 1);
  }

  save(): void {

    // if (this.percentage < 0 || this.percentage > 100) {
    //   this.toastService.error(
    //     'El porcentaje debe estar entre 0 y 100'
    //   );
    //   return;
    // }

    const request = {
      percentage: 100,
      billingRequest: this.billingNits.map(item => ({
        billingNit: item.billingNit,
        billingName: item.billingName
      }))
    };

    this.saving = true;

    this.vendorService
      .updateVendorBillingData(this.vendor.id, request)
      .subscribe({
        next: () => {
          this.vendor.percentage = 100;

          this.saving = false;

          this.toastService.success(
            'Datos de facturación actualizados correctamente'
          );

          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.saving = false;

          this.toastService.error(
            error.error?.message ||
            'No se pudieron actualizar los datos de facturación'
          );
        }
      });
  }

  closeModal(): void {
    this.close.emit(false);
  }

  checkNIT(): void {

    const nit = this.billingNitInput?.trim();

    if (!nit) {
      this.billingNameInput = '';
      this.messageNIT = '';
      return;
    }

    this.companyService.getNitEDX(nit).subscribe({

      next: (response: ResponseObject) => {

        this.messageNIT = '';

        const data = response.data;

        if (data?.hasError) {
          this.billingNameInput = '';
          this.messageNIT =
            data.errorDescription ||
            'Ocurrió un error al consultar el NIT';

          return;
        }

        if (data?.textData?.encontrado) {

          this.billingNameInput =
            data.textData.nombre || '';

        } else {

          this.billingNameInput = '';
          this.messageNIT = 'No se encontró información para el NIT ingresado';

        }

      },

      error: (error: HttpErrorResponse) => {

        console.error(error);

        this.billingNameInput = '';

        this.messageNIT =
          error.error?.message ||
          error.error?.errorDescription ||
          error.message ||
          'No se pudo consultar el NIT';

      }

    });

  }
}